export default {
  'Custom': 'مخصص',
  'Original': 'النسخة الأصلية',
}